import { ROUTES } from "./path"
import React from "react"
import { AppRouteConfig } from "@/types/navigation"
import BoardsList from "@/pages/dashboard/boards/list"
import BoardDetail from "@/pages/dashboard/boards/detail"
import BoardWidgetDetail from "@/pages/dashboard/boards/widget-detail"

export const boardRoutes: AppRouteConfig[] = [
  {
    path: ROUTES.DASHBOARD.BOARDS.LIST,
    element: React.createElement(BoardsList),
    restricted: true,
    showNav: true,
    showSideBar: true,
  },
  {
    path: ROUTES.DASHBOARD.BOARDS.DETAIL(":id"),
    element: React.createElement(BoardDetail),
    restricted: true,
    showNav: true,
    showSideBar: false,
  },
  {
    path: ROUTES.DASHBOARD.BOARDS.WIDGET(":boardId", ":widgetId"),
    element: React.createElement(BoardWidgetDetail),
    restricted: true,
    showNav: true,
    showSideBar: false,
  },
]
